// Scenario 6: new_signup_incomplete
// Fresh signup, no subscription yet. getCurrentSubscription() emits null.
// getAvailablePlans() returns the full plan list for the chosen country.
// On null subscription, /billing route redirects to /signup.

import { Scenario } from './scenario.types';
import { SHARED_PLANS, SHARED_TOP_UP_PACKS } from './shared-plans';

export const newSignupIncomplete: Scenario = {
  name: 'new_signup_incomplete',
  subscription: null,
  plans: SHARED_PLANS,
  invoices: [],
  receipts: [],
  paymentMethod: null,
  aiCreditBalance: null,
  topUpPacks: SHARED_TOP_UP_PACKS
};
